// Falls back to the page's own origin when SERVER_URL isn't baked in at build
// time (deployed-dev ships it empty so one build serves both dev hosts on the
// shared dev DB). Local split-port dev and prod keep explicit env values.
const serverUrl = process.env.SERVER_URL || window.location.origin;

/**
 * Returns a full URL for a given path. If the path is already an absolute URL
 * (http/https) or a data URI, it is returned as-is. Otherwise the server URL
 * is prepended.
 */
export function getFullUrl(path: string | null | undefined): string | null {
  if (!path) return null;
  if (/^https?:\/\//i.test(path) || path.startsWith('data:')) return path;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${serverUrl}${normalizedPath}`;
}
